<script setup>
import Datatable from '@/components/Shared/Table/Datatable.vue';
import {inject, ref} from 'vue';
import FormButton from '@/components/Shared/Form/Button.vue';
import ConfirmDeleteModal from '@/components/Dashboard/ConfirmDeleteModal.vue';

const trans = inject('trans');

const emit = defineEmits(['revoke', 'resend']);

const props = defineProps({
  teamInvitations: {
    type: Array,
    required: true,
  },
});

const headers = [
  {text: trans('common.email'), value: 'email', align: 'start'},
  {text: '', value: 'action', align: 'start'},
];

const showDeleteModal = ref(false);
const invitationToDelete = ref(null);

const showConfirmDeleteInvitation = invitation => {
  invitationToDelete.value = invitation;
  showDeleteModal.value = true;
};

const handleConfirmDeleteInvitation = () => {
  emit('revoke', invitationToDelete.value);
  showDeleteModal.value = false;
  invitationToDelete.value = null;
};
</script>

<template>
  <div>
    <datatable :headers="headers" :items="teamInvitations" :loading="false">
      <template #item-action="{ item }">
        <div v-if="$can('teams.invite')" class="flex gap">
          <form-button
            :value="trans('common.revoke')"
            class="button button_danger"
            @click="showConfirmDeleteInvitation(item)"
            type="button"
          />
          <form-button :value="trans('common.resend')" @click="$emit('resend', item)" type="button"/>
        </div>
      </template>
    </datatable>

    <confirm-delete-modal
      v-if="showDeleteModal"
      :name="`delete-invitation-` + invitationToDelete.id"
      :content="trans('dashboard.account.teams.invitations.delete_invitation_confirmation_description')"
      :header="trans('dashboard.account.teams.invitations.delete_invitation_confirmation_title')"
      @close="showDeleteModal = false"
      @confirm="handleConfirmDeleteInvitation"
    />
  </div>
</template>
